import { Select } from "components-design-system"

// hoc
import InputWrapper from "../../hoc/InputWrapper/InputWrapper"

const RJSelectTag = (props) => {
  let { id, carbonProps, value, onChange } = props

  return (
    <Select
      id={`${id}-field`}
      disabled={carbonProps?.disabled}
      mode={"tags"}
      options={value || []}
      onChange={onChange}
      value={value}
    />
  )
}

export default InputWrapper(RJSelectTag)
